var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInsightGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#EDEDED"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.797 31.2v-24H7.2v25.6h25.6v-1.6zM13.595 20H10.4v3.2h3.2zm2.4-4.799H12.8v3.2H16zm4.798-2.4h-3.2V16h3.2zm0 8h3.2v-3.2H20.8zm1.6 4.798h3.2V22.4H22.4zm8.006-3.199h-3.201v3.2h3.2zm2.4-4.797h-3.2v3.2h3.2z"
})));
export default SvgInsightGraph;